module.exports = __webpack_public_path__ + "media/Strawberries.bd7212e9.mp3";